<div style="margin-top: 1em">
  <p-card>
    <ng-template pTemplate="title"> Информация о тезисе </ng-template>
    <!-- <ng-template pTemplate="subtitle"> Введите информацию </ng-template> -->
    <br />
    <ng-template pTemplate="content">
      <form *ngIf="isFormReady" [formGroup]="thesesForm">
        <h4>Название</h4>
        <editor [init]="initProps" formControlName="titleCtrl"></editor>
        <div *ngIf="
            thesesForm.controls['titleCtrl'].invalid &&
            thesesForm.controls['titleCtrl'].touched
          ">
          <small id="username2-help" class="p-error">Поле не должно быть пустым!</small>
        </div>
        <br />
        <h4>Цель</h4>
        <editor [init]="initProps" formControlName="targetCtrl"></editor>
        <br />
        <h4>Материалы и методы</h4>
        <editor [init]="initProps" formControlName="materialsCtrl"></editor>
        <br />
        <h4>Результаты</h4>
        <editor [init]="initProps" formControlName="resultsCtrl"></editor>
        <br />
        <h4>Выводы</h4>
        <editor [init]="initProps" formControlName="conclusionsCtrl"></editor>
        <br />
      </form>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex flex-row align-items-center justify-content-between mt-3">
        <p-button label="Назад" (onClick)="prevPage()" icon="pi pi-angle-left"></p-button>
        <p-button label="Далее" icon="pi pi-angle-right" iconPos="right" (onClick)="onSubmit(); nextPage()"
          [disabled]="thesesForm.invalid"></p-button>
      </div>
    </ng-template>

  </p-card>
</div>
